<template>
    <div id="footer" class="footer">
        <form v-on:submit.prevent="writeMessage(messageText)">
            <chatinput v-model="messageText" :autocomplete="autocomplete"
                :class="isSpeechToTextAvailable ? 'isSpeechToTextAvailable' : ''"></chatinput>

            <speechToText v-if="isSpeechToTextAvailable" @input="messageText = $event"></speechToText>

            <button type="button" @click="writeMessage(messageText);" :disabled="messageText === ''"></button>
            <div class="attachment">
                <input id="chat-attachment" ref="file" type="file" @change="previewFiles" multiple />
                <label for="chat-attachment"></label>
            </div>
        </form>
    </div>
</template>

<script>
import chatinput from './ChatInput.vue'
import speechToText from './SpeechToText.vue'

export default {
    name: 'chatfooter',
    components: {
        chatinput,
        speechToText,
    },
    props: {
        autocomplete: Object,
        sttEnabled: Boolean
    },
    data() {
        return {
            messageText: '',
            fileType: 'file'
        }
    },
    mounted() {
        const self = this
        // Evento from Messages
        this.$root.$on('selected_files', () => {
            // Reset the input file to allow uploading the same file again.
            self.$refs.file.type = 'hidden'
            self.$refs.file.type = 'file'
        })

        this.$root.$on('speech-to-text.final', () => {
            this.writeMessage(this.messageText);
        });

    },
    methods: {
        writeMessage: function (messageText) {
            messageText = this.stripHtml(messageText);
            this.$root.$emit('send_message', messageText, messageText)
            this.messageText = ''
        },
        previewFiles: function (event) {
            this.$root.$emit('selecting_files', event.target.files)
        },
        stripHtml(string) {
            let doc = (new DOMParser()).parseFromString(string, 'text/html')
            return doc.body.textContent || ""
        },
    },
    computed: {
        isSpeechToTextAvailable: function () {
            return this.sttEnabled && Boolean(window.SpeechRecognition || window.webkitSpeechRecognition);
        }
    }
};
</script>

<style lang="scss">
.footer {
    position: relative;
    width: 100%;
    height: 75px;
    padding-top: 15px;
    z-index: 99;

    input {
        &:focus {
            outline: none;
        }

        &[type='file'] {
            visibility: hidden;
            width: 0px;
            padding: 0px;
        }
    }

    button {
        border-radius: 50%;
        -webkit-appearance: none;
        border: none;
        height: 40px;
        width: 40px;
        text-align: center;
        margin-left: 5px;
        background-color: #000;
        background-image: url("/frontend/img/ico_send.svg");
        background-size: 25px;
        background-position: center center;
        background-repeat: no-repeat;
        color: #fff;

        &:focus {
            outline: none;
        }

        &:disabled {
            opacity: 0.5;
        }

        i {
            font-size: 22px;
        }
    }

    label {
        width: 40px;
        height: 40px;
        margin: 0px !important;
        border-radius: 50%;
        background-size: 1.8em;
        background-repeat: no-repeat;
        background-position: center;
        background-color: #000;
        background-image: url("/frontend/img/attachment.svg");
        cursor: pointer;

        &.disabled {
            opacity: 0.5;
        }
    }

    .attachment {
        float: right;
    }

    .speechToText {
        float: right;
        width: 50px;
        background-size: 25px;
        background-position: center center;
        background-repeat: no-repeat;
        color: #fff;
        border-radius: 50%;
        -webkit-appearance: none;
        border: none;
        height: 40px;
        width: 40px;
        text-align: center;
        margin-left: 5px;
    }

    form {
        max-width: 1000px;
        margin: auto;
    }
}
</style>
